import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Company } from '@tacliatech/types';
import { CompanyModuleGuard } from '@web-frontend/shared/guards/auth';
import { AdminClockHourComponent } from './admin-clock-hour/admin-clock-hour.component';
import { ClockHourComponent } from './clock-hour.component';
import { ClockHourUserComponent } from './clock-hour-user/clock-hour-user.component';
import { PinKioskComponent } from './pin-kiosk/pin-kiosk.component';

const routes: Routes = [
  {
    path: '',
    component: ClockHourComponent,
  },
  {
    path: 'admin',
    canActivate: [],
    component: AdminClockHourComponent,
  },
  {
    path: 'pin',
    canActivate: [CompanyModuleGuard],
    data: {
      tools: [Company.IdTool.StopwatchWithPin],
    },
    component: PinKioskComponent,
  },
  {
    path: 'detail/:userId',
    canActivate: [],
    component: ClockHourUserComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ClockHourRoutingModule {}
